import React from 'react';
import { useConfig } from '../../../../../context';
import { FareGroupV2 } from '@entities/fare';
/**
 * Компонент обертка, достает из конфига настройки для FareGroupV2
 */
const FareGroup = props => {
    const { global: { fareGroupVariant, showFareGroupUpgradeOptions } } = useConfig();
    return React.createElement(FareGroupV2, Object.assign({ variant: fareGroupVariant, showUpgradeOptions: showFareGroupUpgradeOptions }, props));
};
export default FareGroup;
